"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCard = void 0;

var _Helper = require("./../utils/Helper");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CreditCard =
/*#__PURE__*/
function () {
  function CreditCard(number, cardType) {
    _classCallCheck(this, CreditCard);

    _defineProperty(this, "number", void 0);

    _defineProperty(this, "cardType", void 0);

    this.cardType = cardType;
    this.number = number;

    if (this.number && this.number.length) {
      this.formatCardNumber();
    }
  }

  _createClass(CreditCard, [{
    key: "getCardTypes",
    value: function getCardTypes() {
      return [{
        name: 'Visa',
        nbDigits: [13, 16],
        prefixes: [4]
      }, {
        name: 'MasterCard',
        nbDigits: [16],
        prefixes: [51, 52, 53, 54, 55]
      }, {
        name: 'Amex',
        nbDigits: [15],
        prefixes: [34, 37]
      }, {
        name: 'VisaElectron',
        nbDigits: [16],
        prefixes: [6304, 6706, 6771, 6709]
      }];
    }
  }, {
    key: "formatCardNumber",
    value: function formatCardNumber() {
      // Remove any dashes from the credit card number
      this.number = this.number.replace(/-/g, ''); // Remove any spaces from the credit card number

      this.number = this.number.replace(/\s/g, "");
    }
  }, {
    key: "getCard",
    value: function getCard() {
      var _this = this;

      return this.getCardTypes().filter(function (card) {
        return card.name === _this.cardType;
      }).shift();
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (this.isValidCardType() && this.isValidLuhnNumber()) {
        if (!this.isValidNbDigits() || !this.isValidPrefix()) {
          return false;
        } // validate prefixes


        return true;
      }

      return false;
    }
  }, {
    key: "isValidCardType",
    value: function isValidCardType() {
      return !!this.getCard();
    }
  }, {
    key: "isValidLuhnNumber",
    value: function isValidLuhnNumber() {
      return (0, _Helper.luhn10)(this.number);
    }
  }, {
    key: "isValidNbDigits",
    value: function isValidNbDigits() {
      return this.getCard().nbDigits.includes(this.number.length);
    }
  }, {
    key: "isValidPrefix",
    value: function isValidPrefix() {
      var _this2 = this;

      var valid = false;
      this.getCard().prefixes.forEach(function (prefix) {
        if ((0, _Helper.Str)(_this2.number).starts_with(prefix)) valid = true;
      });
      return valid;
    }
  }]);

  return CreditCard;
}();

exports.CreditCard = CreditCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@primitivesocial/ps-validation/dist/Classes/CreditCard.js
// module id = N7G0
// module chunks = 0 1